import { useDashboardPermissions } from '@components'
import { useOrdersStatisticsQuery } from '@hooks/useOrdersQuery/useOrdersStatisticsQuery'
import { useDashboardStatisticsQuery } from '@queries'

import type { ShopStage } from './types'
import { getProfit, getShopStageObject } from './utils'

const staleTime = 60_000 // 1 minute

export const useShopStage = (): { shopStage: ShopStage; isLoading: boolean } => {
  const { hasPermission } = useDashboardPermissions()
  const { dashboardStatisticsQuery } = useDashboardStatisticsQuery(undefined, {
    staleTime,
    enabled: hasPermission('home.analytics'),
  })
  const { getOrdersStatisticsQuery } = useOrdersStatisticsQuery([{ types: ['COMMON'] }], {
    staleTime,
    enabled: hasPermission('contributions.orders.statistics'),
  })

  const getShopStage = (): ShopStage => {
    const profit = getProfit(dashboardStatisticsQuery.data)

    return getShopStageObject(profit, getOrdersStatisticsQuery?.data?.value)
  }

  return {
    shopStage: getShopStage(),
    isLoading:
      dashboardStatisticsQuery.isInitialLoading || getOrdersStatisticsQuery.isInitialLoading,
  }
}
